module.exports = __webpack_public_path__ + "img/ic_nav_trainieren.0bdc18fc.svg";